import { render, staticRenderFns } from "./Associations.vue?vue&type=template&id=87941782&scoped=true&"
import script from "./Associations.vue?vue&type=script&lang=js&"
export * from "./Associations.vue?vue&type=script&lang=js&"
import style0 from "./Associations.vue?vue&type=style&index=0&id=87941782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87941782",
  null
  
)

export default component.exports